import { render } from "./ProfileSettingsPage.vue?vue&type=template&id=64e29eb5"
import script from "./ProfileSettingsPage.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__